<template>
  <div :class="variant === 'header' ? 'buscador-header-wrapper' : ''">

    <!-- Variante header: input nativo estilo ML -->
    <div v-if="variant === 'header'" class="buscador-header" :class="{ 'buscador-header--focused': isFocused }">
      <v-icon class="buscador-header-icon" size="20" color="#666">mdi-magnify</v-icon>
      <input
        ref="headerInput"
        v-model="inputSearch"
        class="buscador-header-input"
        :placeholder="placeholderProp"
        autocomplete="off"
        @keyup.enter="eventEnter(inputSearch)"
        @focus="handleFocus"
        @blur="handleBlur"
      />
      <button
        v-if="inputSearch"
        class="buscador-header-clear"
        @mousedown.prevent="clearSearch"
      >
        <v-icon size="18" color="#999">mdi-close</v-icon>
      </button>
      <button class="buscador-header-btn" @click="eventEnter(inputSearch)">
        <v-icon size="22" color="#999">mdi-magnify</v-icon>
      </button>

      <!-- Dropdown de sugerencias -->
      <div v-if="productos.length && isFocused" class="buscador-header-dropdown">
        <div
          v-for="item in productos"
          :key="item.psp_id || item.descripcion"
          class="buscador-header-dropdown-item"
          @mousedown.prevent="seleccionarItem(item)"
        >
          <v-icon size="16" color="#888" class="mr-2">mdi-magnify</v-icon>
          {{ item.descripcion }}
        </div>
      </div>
    </div>

    <!-- Variante default (existente) -->
    <v-autocomplete
      v-else
      :search-input="inputSearch"
      @update:search-input="val => { if (!isInitializing) inputSearch = val }"
      v-model="inputSelectProducto"
      class="ml-search-dark"
      outlined
      hide-no-data
      hide-details
      :items="productos"
      :loading="isLoading"
      @keyup.enter="eventEnter(inputSearch)"
      :placeholder="placeholderProp"
      :cache-items="showSuggest"
      ref="productosApi"
      item-text="descripcion"
      :item-value="emitObject ? item => item : 'descripcion'"
      @click:clear="clearSearch"
      clearable
      @focus="handleFocus"
      @blur="handleBlur"
    >
      <template v-slot:append>
        <div class="search-divider"></div>
        <v-btn icon small class="search-btn" @click="eventEnter(inputSearch)">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>

      <template v-slot:item="data">
        <v-list-item v-bind="data.attrs" v-on="data.on">
          <v-list-item-avatar>
            <v-icon size="18">mdi-magnify</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.descripcion }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>

  </div>
</template>

<script>
import ProductosAPI from "@/api/productos";

export default {
  name: "producto.buscador",

  props: {
    categorias: { type: Array, default: () => [] },
    usarProductoEmpresa: { type: Boolean, default: false },
    placeholderProp: { type: String, default: "Buscar" },
    showSuggest: { type: Boolean, default: true },
    emitObject: { type: Boolean, default: false },
    variant: { type: String, default: "default" }, // "default" | "header"
  },

  data() {
    return {
      inputSearch: "",
      inputSelectProducto: null,
      isLoading: false,
      productos: [],
      borrando: false,
      isFocused: false,
      isInitializing: false,
      _debounceTimer: null,
    };
  },

  watch: {
    '$route.query.q': {
      immediate: true,
      handler(q) {
        this.loadFromQuery(q);
      }
    },

    inputSelectProducto(val) {
      if (!val) return;
      this.$emit("process-buscador-producto-select", val);
      this.$nextTick(() => {
        this.inputSearch = "";
        this.productos = [];
      });
    },

    inputSearch(val) {
      if (this.isInitializing) return;

      if (!val || val.length < 2) {
        this.productos = [];
        this.inputSelectProducto = null;
        return;
      }

      if (this.isLoading || this.borrando) return;

      if (this.inputSelectProducto && val !== this.inputSelectProducto) {
        this.inputSelectProducto = null;
      }

      if (!this.showSuggest) {
        this.productos = [];
        return;
      }

      // Debounce para evitar requests por cada caracter del scanner
      clearTimeout(this._debounceTimer);
      this._debounceTimer = setTimeout(() => {
        this.getFromSearch(val);
      }, this.variant === 'header' ? 300 : 0);
    }
  },

  methods: {
    loadFromQuery(q) {
      const textoNormalizado = q ? q.replace(/-/g, " ") : "";
      if (this.inputSearch === textoNormalizado) return;

      this.isInitializing = true;
      this.inputSearch = textoNormalizado;
      this.productos = [];

      this.$nextTick(() => {
        this.inputSearch = textoNormalizado;
        this.isInitializing = false;
      });
    },

    handleFocus() { this.isFocused = true; },
    handleBlur() { this.isFocused = false; },

    clearSearch() {
      this.inputSearch = "";
      this.productos = [];
      this.inputSelectProducto = null;

      if (this.$route.query.q || this.$route.query.barcode) {
        const query = { ...this.$route.query };
        delete query.q;
        delete query.barcode;
        this.$router.replace({ query });
      }
    },

    async getFromSearch(input_search) {
      try {
        this.isLoading = true;
        const replaced = input_search.trim().replace(/\s+/g, "-");
        
        const response = this.usarProductoEmpresa 
          ? await ProductosAPI.getSuggestEmpresa(replaced, this.categorias)
          : await ProductosAPI.getSuggest(replaced, this.categorias);

        this.productos = response?.data?.results || [];
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    seleccionarItem(item) {
      this.inputSearch = item.descripcion;
      this.productos = [];
      this.$emit("process-buscador-producto-select", this.emitObject ? item : item.descripcion);
    },

    eventEnter(inputSearch) {
      if (!inputSearch) return;
      const search = inputSearch.trim();
      if (!search) return;

      this.productos = [];
      if (this.$refs.productosApi) {
        this.$refs.productosApi.isMenuActive = false;
      }
      this.$emit("process-buscador-producto", search);
    },
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      this.borrando = event.keyCode === 8;
      if (event.code === "Delete") {
        this.clearSearch();
      }
    });
  },
};
</script>

<style scoped>
/* ── Variante default ── */
.ml-search-dark { max-width: 720px; margin: 0 auto; }
.ml-search-dark ::v-deep .v-input__slot { background-color: #2b2b2b !important; border-radius: 8px !important; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3) !important; min-height: 48px !important; }
.ml-search-dark.v-input--is-focused ::v-deep .v-input__slot { background-color: #1e1e1e !important; border-color: #3483fa !important; }
.ml-search-dark ::v-deep input { color: #eeeeee !important; }
.ml-search-dark ::v-deep .v-menu__content { background-color: #2b2b2b !important; border: 1px solid #3d3d3d; }
.search-divider { width: 1px; height: 24px; background-color: #3d3d3d; margin-right: 8px; }
.search-btn { margin-right: -8px !important; color: #9e9e9e !important; }

/* ── Variante header ── */
.buscador-header-wrapper {
  flex: 1;
  max-width: 600px;
}

.buscador-header {
  display: flex;
  align-items: center;
  background: #2a2a2a;
  border: 2px solid #3a3a3a;
  border-radius: 4px;
  height: 42px;
  position: relative;
  transition: border-color 0.15s ease;
  overflow: visible;
}

.buscador-header--focused {
  border-color: #3483fa;
}

.buscador-header-icon {
  flex-shrink: 0;
  margin: 0 10px 0 12px;
}

.buscador-header-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #eeeeee;
  font-size: 0.95rem;
  height: 100%;
  min-width: 0;
}

.buscador-header-input::placeholder {
  color: #777;
}

.buscador-header-clear {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0 6px;
  display: flex;
  align-items: center;
}

.buscador-header-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  border-left: 1px solid #3a3a3a;
  height: 42px;
  width: 44px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -2px;
  transition: background 0.12s ease;
}

.buscador-header-btn:hover {
  background: rgba(255, 255, 255, 0.05);
}

/* Dropdown */
.buscador-header-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: -2px;
  right: -2px;
  background: #1e1e1e;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  z-index: 999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  max-height: 320px;
  overflow-y: auto;
}

.buscador-header-dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 0.88rem;
  color: #cccccc;
  cursor: pointer;
  transition: background 0.1s ease;
}

.buscador-header-dropdown-item:hover {
  background: #2a2a2a;
}
</style>